<template>
  <div class="signature" style="position: relative;" @touchmove.prevent>
    <div style="font-size: 0.6rem;position: absolute; left: -20vw; top: 20vw;  width: 12rem; transform: rotate(-90deg);">请将手机横屏后填写签名</div>
    <div class="boardBox" ref="boardBox">
      <canvas ref="board" id="canvas" @touchstart="mStart" @touchmove="mMove" @touchend="mEnd"></canvas>
    </div>
    <div class="bar">
      <div class="item" @click="goback">
        <div class="text" style="color: red;">退出</div>
      </div>
      <div class="item" @click="clearcanvas">
        <div class="text">重绘</div>
      </div>
      <div class="item" @click="getcanvas">
        <div class="text" style="color: green">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getOssToken} from "../../../api/order";
import OSS from "ali-oss";
import {getFileRealPath, getFileUrl, uploadWithoutOssToken} from "../../../api/util";

export default {
  data() {
    return {
      familySignatureUrl: '',
      pictureUrl: '',
      baseData: "",
      ctx: null,
      point: {
        x: 0,
        y: 0,
      },
      moving: false, // 是否正在绘制中且移动
    };
  },
  mounted() {
    let board = this.$refs.board; // 获取DOM
    board.width = this.$refs.boardBox.offsetWidth; // 设置画布宽
    board.height = this.$refs.boardBox.offsetHeight; // 设置画布高
    this.ctx = board.getContext("2d"); // 二维绘图
    this.ctx.strokeStyle = "#000"; // 颜色
    this.ctx.lineWidth = 3; // 线条宽度
  },
  created() {
    console.log('userAgent.....', navigator.userAgent)
  },
  methods: {
    // 触摸(开始)
    mStart(e) {
      let x = e.touches[0].clientX - e.target.offsetLeft,
        y = e.touches[0].clientY - e.target.offsetTop; // 获取触摸点在画板（canvas）的坐标
      this.point.x = x;
      this.point.y = y;
      this.ctx.beginPath();
      this.moving = true;
    },
    // 滑动中...
    mMove(e) {
      if (this.moving) {
        let x = e.touches[0].clientX - e.target.offsetLeft,
          y = e.touches[0].clientY - e.target.offsetTop; // 获取触摸点在画板（canvas）的坐标
        this.ctx.moveTo(this.point.x, this.point.y); // 把路径移动到画布中的指定点，不创建线条(起始点)
        this.ctx.lineTo(x, y); // 添加一个新点，然后创建从该点到画布中最后指定点的线条，不创建线条
        this.ctx.stroke(); // 绘制
        (this.point.x = x), (this.point.y = y); // 重置点坐标为上一个坐标
      }
    },
    // 滑动结束
    mEnd() {
      if (this.moving) {
        this.ctx.closePath(); // 停止绘制
        this.moving = false; // 关闭绘制开关
      }
    },
    getcanvas() {
      // 获取画布内容的有效区域
      const trimmedCanvas = this.trimCanvas();
      trimmedCanvas.toDataURL("image/png");
      trimmedCanvas.toBlob(async (blobObj) => {
        var file1 = new File([blobObj], "pic.png", {
          type: blobObj.type,
          lastModified: Date.now(),
        });
        console.log('file......', file1)
        this.convertImg(file1);
      });
    },
    // 新增方法：裁剪画布空白区域
    trimCanvas() {
      const canvas = this.$refs.board;
      const ctx = canvas.getContext("2d");
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixels = imageData.data;
      let xMin = canvas.width;
      let xMax = 0;
      let yMin = canvas.height;
      let yMax = 0;

      for (let y = 0; y < canvas.height; y++) {
        for (let x = 0; x < canvas.width; x++) {
          const index = (y * canvas.width + x) * 4;
          if (pixels[index + 3] !== 0) { // 检测非透明像素
            xMin = Math.min(xMin, x);
            xMax = Math.max(xMax, x);
            yMin = Math.min(yMin, y);
            yMax = Math.max(yMax, y);
          }
        }
      }

      if (xMax === 0 && yMax === 0) {
        return canvas; // 如果没有绘制内容，返回原画布
      }

      const trimmedCanvas = document.createElement("canvas");
      trimmedCanvas.width = xMax - xMin + 1;
      trimmedCanvas.height = yMax - yMin + 1;
      const trimmedCtx = trimmedCanvas.getContext("2d");
      trimmedCtx.putImageData(
        ctx.getImageData(xMin, yMin, trimmedCanvas.width, trimmedCanvas.height),
        0, 0
      );

      return trimmedCanvas;
    },
    //旋转图片
    convertImg(file) {
      let _this = this;
      var canvas1 = document.createElement("canvas");
      var context1 = canvas1.getContext("2d");
      var oReader = new FileReader();
      oReader.readAsDataURL(file);
      oReader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        img.onload = function () {
          // 图片原始尺寸
          var originWidth = this.width;
          var originHeight = this.height;
          // 最大尺寸限制
          var maxWidth = 1080,
            maxHeight = 1080;
          // 目标尺寸
          var targetWidth = originWidth,
            targetHeight = originHeight;
          // 图片尺寸超过300x300的限制
          if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
              targetWidth = maxWidth;
              targetHeight = Math.round(
                maxWidth * (originHeight / originWidth)
              );
            } else {
              targetHeight = maxHeight;
              targetWidth = Math.round(
                maxHeight * (originWidth / originHeight)
              );
            }
          }
          var type = "image/jpeg";
          // canvas对图片进行缩放
          canvas1.width = targetHeight;
          canvas1.height = targetWidth;
          // 旋转90度
          context1.translate(0, 0);
          context1.rotate(Math.PI / 2);
          // (0,-imgHeight) 从旋转原理图那里获得的起始点
          // context.clearRect(0,  -targetHeight, targetWidth, targetHeight);
          context1.drawImage(img, 0, -targetHeight, targetWidth, targetHeight);
          // 将canvas的透明背景设置成白色
          var imageData = context1.getImageData(
            0,
            0,
            canvas1.width,
            canvas1.height
          );
          for (var i = 0; i < imageData.data.length; i += 4) {
            // 当该像素是透明的，则设置成白色
            if (imageData.data[i + 3] == 0) {
              imageData.data[i] = 255;
              imageData.data[i + 1] = 255;
              imageData.data[i + 2] = 255;
              imageData.data[i + 3] = 255;
            }
          }
          context1.putImageData(imageData, 0, 0);
          var dataurl = canvas1.toDataURL(type);
          _this.basedata = dataurl;
          console.log(dataurl);
          _this.updatavue();
        };
      };
    },
    //base64转Blob
    base64ToBlob(base64Data) {
      let arr = base64Data.split(","),
        fileType = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        l = bstr.length,
        u8Arr = new Uint8Array(l);

      while (l--) {
        u8Arr[l] = bstr.charCodeAt(l);
      }
      return new Blob([u8Arr], {
        type: fileType,
      });
    },
    //上传图片
    async updatavue() {
      //转成file文件
      let blobObj = this.base64ToBlob(this.basedata);
      var file = new File([blobObj], "pic.png", {
        type: blobObj.type,
        lastModified: Date.now(),
      });
      //此处为发送请求给后台获取图片路径
      this.uploadImg(file)
    },
    async uploadImg (file) {
      let fileSuffix = ''
      if (file.type === 'image/jpeg') {
        fileSuffix = 'jpeg'
      }
      if (file.type === 'image/png') {
        fileSuffix = 'png'
      }
      if (file.type === 'image/jpg') {
        fileSuffix = 'jpg'
      }
      await uploadWithoutOssToken({ file_suffix: fileSuffix }).then((res) => {
        if (res.data.data) {
          const ossData = res.data.data
          const client = new OSS({
            region: 'oss-' + ossData.region_id,
            accessKeySecret: ossData.access_secret,
            accessKeyId: ossData.access_id,
            stsToken: ossData.secret_token,
            bucket: ossData.bucket
          })
          client.put(ossData.file_name, file).then((result) => {
            if (result && result.url) {
              getFileUrl({file_id: ossData.file_id}).then((res) => {
                if (res.data.data && res.data.data.file_url_original) {
                  this.pictureUrl = res.data.data.file_url_original
                  this.$emit("setShow", { url: res.data.data.file_url_original, file_id: ossData.file_id })
                  this.$forceUpdate()
                }
              })

            }
          })
        }
      })
    },
    //清除画布
    clearcanvas() {
      var c = document.getElementById("canvas");
      var cxt = c.getContext("2d");
      c.height = c.height;
      this.ctx.lineWidth = 3;
    },
    //返回上一级
    goback() {
      this.$emit("setShow", '');
    },
  },

};

</script>

<style scoped>
   .loadingtext {
     transform: rotate(-90deg);
     color: red;
   }
   .item {
     -webkit-transform: rotate(-90deg);
   }
.text {
  text-align: center;
}

.boardBox {
  width: 100vw;
  height: 80vh;
  background: #f9f9f9;
}

.bar {
  box-sizing: border-box;
  padding: 0rem 1rem;
  display: flex;
  width: 100vw;
  height: 8vh;
  background-color: #ffffff;
  justify-content: space-around;
  align-items: center;
}
.shade {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  background-color: #333333;
  z-index: 66666;
  opacity: 0.9;
}
   .minishade {
     width: 100%;
     height: 100%;
     display: flex;
     align-items: center;
     justify-content: center;
   }
</style>



// WEBPACK FOOTER //
// src/views/user/components/sign_name.vue